import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'

import styles from './Chip.module.scss'

type ChipProps = {
  className?: string
  color?: string
  label?: React.ReactNode
  size?: string
  variant?: string
}

export const Chip = ({ className, color, label, size, variant }: ChipProps) => (
  <Box
    align="center"
    className={cx(
      styles.chip,
      styles.color,
      styles.variant,
      { [styles.size]: Boolean(size) },
      color && styles[color],
      size && styles[size],
      variant && styles[variant],
      className,
    )}
    justify="center"
    tagName="span"
  >
    {label}
  </Box>
)
